import { default as ArrowBackIconMUI } from '@mui/icons-material/ArrowBack';

export const ArrowLeftIcon = ArrowBackIconMUI;
